/**
 * Course component styles.
 */
import { Styles } from 'react-jss';

export default {
  courseDetails: {
    marginLeft: '20px',
    marginTop: '10px',
  },
  optional: {
    opacity: 0.7,
  },
  bookPanel: {
    marginLeft: '20px',
    marginTop: '6px',
    paddingBottom: '10px',
  },
} as Styles;
